type FeatureFlags = {
  esgMetrics?: boolean
  esgMetricsEnvironmentTab?: boolean
  esgMetricsSocialTab?: boolean
  esgMetricsGovernanceTab?: boolean
  enableDatePickerOnDashboard?: boolean
  esgDataEntryPage?: boolean
  supplierPortal?: boolean
}

type DomainFlags = {
  [key: string]: FeatureFlags
}

export default defineNuxtPlugin(() => {
  // Define the default feature flag values
  // These values will be used if the current domain doesn't have specific overrides
  const defaultFeatureFlags: FeatureFlags = {
    // Define your feature flags here with their default values
    esgMetrics: true,
    esgMetricsEnvironmentTab: false,
    esgMetricsSocialTab: false,
    esgMetricsGovernanceTab: false,
    enableDatePickerOnDashboard: true,
    supplierPortal: false,
  }

  // Get the current domain from the window location
  const currentDomain = window.location.hostname

  // Define domain-specific feature flag overrides
  // If the current domain matches one of the defined domains,
  // the corresponding feature flag values will be used instead of the defaults
  const domainFlags: DomainFlags = {
    // disabled in all production clients except for 'smrt.myveridis'
    'smrt.myveridis': {
      esgMetricsEnvironmentTab: true,
      esgMetricsSocialTab: true,
      esgMetricsGovernanceTab: true,
      esgDataEntryPage: true,
    },
    'tradex.myveridis': {
      esgMetricsEnvironmentTab: true,
      esgMetricsSocialTab: true,
      esgMetricsGovernanceTab: true,
      esgDataEntryPage: true,
      supplierPortal: true,
    },
    'giti-tire.myveridis': {
      esgMetricsEnvironmentTab: true,
      esgMetricsSocialTab: true,
      esgMetricsGovernanceTab: true,
      esgDataEntryPage: true,
    },
    'motul.myveridis': {
      esgMetricsEnvironmentTab: true,
      esgMetricsSocialTab: true,
      esgMetricsGovernanceTab: true,
      esgDataEntryPage: true,
    },
    'valdivian.myveridis': {
      esgMetricsEnvironmentTab: true,
      esgMetricsSocialTab: true,
      esgMetricsGovernanceTab: true,
      esgDataEntryPage: true,
    },
    'dragonfly.myveridis': {
      esgMetricsEnvironmentTab: true,
      esgMetricsSocialTab: true,
      esgMetricsGovernanceTab: true,
      esgDataEntryPage: true,
    },
    'quantum.myveridis': {
      esgMetricsEnvironmentTab: true,
      esgMetricsSocialTab: true,
      esgMetricsGovernanceTab: true,
      esgDataEntryPage: true,
    },
    'borneo-foods.myveridis': {
      esgMetricsEnvironmentTab: true,
      esgMetricsSocialTab: true,
      esgMetricsGovernanceTab: true,
      esgDataEntryPage: true,
    },
    'trustora.myveridis': {
      esgMetricsEnvironmentTab: true,
      esgMetricsSocialTab: true,
      esgMetricsGovernanceTab: true,
      esgDataEntryPage: true,
    },
    'defence-collective-singapore.myveridis': {
      esgMetricsEnvironmentTab: true,
      esgMetricsSocialTab: false,
      esgMetricsGovernanceTab: false,
      esgDataEntryPage: true,
    },
    'hafary-pte-ltd.myveridis': {
      esgMetricsEnvironmentTab: true,
      esgMetricsSocialTab: true,
      esgMetricsGovernanceTab: true,
      esgDataEntryPage: true,
    },
    'cahya-mata.myveridis': {
      esgMetricsEnvironmentTab: true,
      esgMetricsSocialTab: true,
      esgMetricsGovernanceTab: true,
      esgDataEntryPage: true,
    },
    'rp-training.myveridis': {
      esgMetricsEnvironmentTab: true,
      esgMetricsSocialTab: true,
      esgMetricsGovernanceTab: true,
      esgDataEntryPage: true,
    },
    'republic-polytechnic.myveridis': {
      esgMetricsEnvironmentTab: true,
      esgMetricsSocialTab: true,
      esgMetricsGovernanceTab: true,
      esgDataEntryPage: true,
    },
    // enable for all localhost domains
    'localhost': {
      esgMetricsEnvironmentTab: true,
      esgMetricsSocialTab: true,
      esgMetricsGovernanceTab: true,
      esgDataEntryPage: true,
      enableDatePickerOnDashboard: true,
      supplierPortal: true,
    },
    // enable for all goveridis.com(dev env Nuxt 2) domains
    'goveridis.com': {
      esgMetricsEnvironmentTab: true,
      esgMetricsSocialTab: true,
      esgMetricsGovernanceTab: true,
      esgDataEntryPage: true,
      enableDatePickerOnDashboard: true,
    },
    // enabled for all veridis.us domains
    'veridis.us': {
      esgMetricsEnvironmentTab: true,
      esgMetricsSocialTab: true,
      esgMetricsGovernanceTab: true,
      esgDataEntryPage: true,
      enableDatePickerOnDashboard: true,
    },
    // enabled for all veridis.vercel.app domains
    'veridis.vercel.app': {
      esgMetricsEnvironmentTab: true,
      esgMetricsSocialTab: true,
      esgMetricsGovernanceTab: true,
      esgDataEntryPage: true,
      enableDatePickerOnDashboard: true,
    },
  }

  // Check if the current domain has specific feature flag overrides
  // If a match is found, merge the domain-specific flags with the default flags
  for (const domain of Object.keys(domainFlags)) {
    if (currentDomain.includes(domain)) {
      Object.assign(defaultFeatureFlags, domainFlags[domain])
      break
    }
  }

  // Inject the merged feature flags into the Nuxt context
  // This makes the feature flags available throughout the application
  return {
    provide: {
      featureFlags: defaultFeatureFlags,
    },
  }
})
